import { privateRequest } from "../axios";
import type {
  GetUsersParams,
  GetUsersResponse,
  User,
  ApiResponse,
} from "@/types/user";

const ENDPOINTS = {
  USER: "/user",
  USER_ID: (id: string) => `/user/${id}`,
};

const getUsers = async (params?: GetUsersParams): Promise<GetUsersResponse> => {
  const response = await privateRequest.get<ApiResponse<GetUsersResponse>>(
    ENDPOINTS.USER,
    { params }
  );

  // Extract only what your Redux store expects
  return {
    rows: response.data.data.rows ?? [],
    count: response.data.data.count ?? 0,
  };
};

const getUserById = async (id: string): Promise<User> => {
  const response = await privateRequest.get<User>(ENDPOINTS.USER_ID(id));
  return response.data;
};

const addUser = async (data: Partial<User>): Promise<User> => {
  const response = await privateRequest.post<User>(ENDPOINTS.USER, data);
  return response.data;
};

const updateUser = async (id: string, data: Partial<User>): Promise<User> => {
  const response = await privateRequest.put<User>(ENDPOINTS.USER_ID(id), data);
  return response.data;
};

const deleteUser = async (
  id: string | number
): Promise<{ message: string }> => {
  const response = await privateRequest.delete<{ message: string }>(
    ENDPOINTS.USER_ID(String(id))
  );
  return response.data;
};

const UserService = {
  getUsers,
  getUserById,
  addUser,
  updateUser,
  deleteUser,
};

export default UserService;
export type { User };
